<div class="d-flex flex-column align-items-center justify-content-center p-5 w-100 h-100">
    <div class="d-flex flex-column align-items-center">
        <div>
            <h5 class="font-weight-bold text-center p-2">
                <span class="text-primary">{{ numberOfCommunityUsers }}</span>
                {{ 'home.onboardingProfile.displayMemberTitle' | translate }}
            </h5>
        </div>
        <div class="h-100 w-100 d-flex align-items-center p-2">
            <div class="profile-container d-flex flex-wrap justify-content-center">
                <div *ngFor="let profile of profiles" class="profile">
                    <img [src]="profile.photoUrl" alt="{{ profile.name }}" class="profile-image" />
                </div>
            </div>
        </div>

        <app-user-avatar
            [firstName]="currentUser.firstName"
            [lastName]="currentUser.lastName"
            [picture]="currentUser.pictureReference"
        ></app-user-avatar>

        <footer class="p-3">
            <h5 class="font-weight-bold">{{ 'home.onboardingProfile.andYou' | translate }}</h5>
        </footer>
    </div>
</div>
